import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onClick"];
import React, { forwardRef } from 'react';
import { StyledPropertyCardBody } from './PropertyCardBody.styles';

/**
 * Used to add card styles and behaviors to the `PropertyCard`. Extends `Card`.
 *
 * @extends Card
 * @since 8.63.0
 */
export var PropertyCardBody = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var handleClick = function handleClick(e) {
    // CDS-3631: Ensure clicks on child elements don't trigger PropertyCard.Body's `onClick`
    // without using stopPropagation
    var isExcludedElement = e.target.closest('[data-c11n-component="PropertyCard.MenuPopper"]') || e.target.closest('[data-c11n-component="PropertyCard.SaveButton"]') || e.target.closest('[data-c11n-component="PhotoCarousel.NavControl"]');
    if (isExcludedElement) {
      return;
    }
    if (typeof onClick === 'function') {
      onClick(e);
    }
  };
  return /*#__PURE__*/React.createElement(StyledPropertyCardBody, _extends({
    ref: forwardedRef,
    appearance: "borderless",
    cardType: "secondary",
    role: undefined,
    onClick: handleClick
  }, rest));
});
PropertyCardBody.displayName = 'PropertyCard.Body';